import $ from 'jquery';

export function track(eventName) {
  if (!eventName || typeof window.fbq !== 'function') {
    return false;
  }

  return window.fbq('trackCustom', eventName);
}

export function trackElement($element) {
  const fbqEvent = $element.data('fbqEvent');
  return track(fbqEvent);
}

export function trackClicks() {
  $(document.body).on('click.fbq', 'a[data-fbq-event], button[data-fbq-event]', (evt) => {
    trackElement($(evt.currentTarget));
  });
}

export function trackViewContent(contentId, productType) {
  if (typeof window.fbq !== 'function') {
    return false;
  }

  return window.fbq('track', 'ViewContent', {
    /* eslint-disable babel/camelcase */
    content_ids: [contentId],
    product_type: productType,
    /* eslint-enable babel/camelcase */
  });
}
